import React, { useState } from "react";
import { connect } from "react-redux";
import { Button, NumberBox, Popup, ScrollView, SelectBox, TextBox } from "devextreme-react";
import axios from "axios";
import { alert } from "devextreme/ui/dialog";
import { LocationPickMethodOptions, LotPickMethodShipments, MethodShipments, PickSequence, SortDirectionOptions, SublotPickMethodShipments, UnitPickMethodShipments } from "../../../../../../enum/TransactionDataEntryEnum";
import { ShowMasterLot, TransactionTypes } from "../../../../../../enum/Enum";
import data from "../../../../../../assets/apiRoutes.json";
import { CONCURRENCY_HANDLED, getApiErrorMessage } from "../../../../../../common/concurrency";
import { MESSAGES } from "../../../../../../common/Messages";

function AutoSelectLocationPopup(props) {
    var accessToken = props.oidc.user.access_token;
    const [selectedPickMethod, setSelectedPickMethod] = useState({LocationPickMethod:props.showPopup.pickMethods.LocationPickMethod,LocationPickSeqMethod:props.showPopup.pickMethods.LocationPickSeqMethod});
    const callStageChangeProcedure = () => {
        props.showPopup.setLoadPanelVisible(true);
        const requestData = {
            recordType:props.showPopup.parentFormFields.RECORDTYPE,
            headerRowId: props.showPopup.parentFormFields.ROWID,
            transactionType: props.showPopup.parentFormFields.TRANSACTIONTYPE,
            fromStage: TransactionTypes.Invoice,
            toStage: props.showPopup.parentFormFields.STAGE,
            detailRowId:props.showPopup.formFields.ROWID,
            subDetailRowId: props.showPopup.subDetail?.rowid??null,
            defaultReceiptWH: null,
            receiptLocationMethod: props.showPopup.profile?.LocationmethodReceipts,
            locationMethod: props.showPopup.pickMethods.LocationMethod??MethodShipments.AutoSelect,
            locationPickMethod: selectedPickMethod.LocationPickMethod, //m
            locationPickSequence: selectedPickMethod.LocationPickSeqMethod, //seq
            lotMethod: props.showPopup.pickMethods.LotMethod??MethodShipments.Manual,
            lotPickMethod: props.showPopup.pickMethods.LotPickMethod??LotPickMethodShipments.LotCode,
            lotPickSequence: props.showPopup.pickMethods.LotPickSeqMethod,
            subLotMethod: props.showPopup.pickMethods.SublotMethod,
            subLotPickMethod: props.showPopup.pickMethods.SublotPickMethod??SublotPickMethodShipments.SublotCode,
            subLotPickSequence: props.showPopup.pickMethods.SublotPickSeqMethod??PickSequence.Ascending,
            unitMethod: props.showPopup.pickMethods.UnitMethod,
            unitPickMethod:props.showPopup.pickMethods.UnitPickMethod??UnitPickMethodShipments.UnitCode,
            unitPickSequence:props.showPopup.pickMethods.UnitPickSeqMethod??PickSequence.Ascending,
            shipmentsOnNegAvl: props.showPopup.profile?.ShipmentsonnegAvl??ShowMasterLot.None,
            mode:ShowMasterLot.None
        }; axios.post
            (
                `${window._env_.REACT_APP_APIS}/${data.Transaction.CallStageChangeProcedure}`,
                requestData,
                {
                    headers: {
                        "Content-Type": "application/json",
                        access_token: accessToken,
                    },
                }
            )
            .then((res) => {
                 props.setShowPopup(prevFormData => ({ ...prevFormData, visible: false }));
                if (props.showPopup.primaryDataGrid.current) {
                    props.showPopup.primaryDataGrid.current.instance().refresh();
                }
                if (props.showPopup.subDetail?.rowid && props.showPopup.locationDataGridRef.current) {
                    props.showPopup.locationDataGridRef.current.instance().refresh();
                }
            })
            .catch((err) => {
                props.showPopup.detailGrid.current.instance().endCustomLoading();
                if (err?.[CONCURRENCY_HANDLED]) {
                    return;
                }
                // CallStageChangeProcedure now answers 500 on a throw instead of letting it escape
                // unhandled, so this catch is live. It was `alert(err, "Error")`, which rendered the
                // literal text "[object Object]".
                alert(getApiErrorMessage(err, MESSAGES.ERROR), "Error");
            }).finally(()=>props.showPopup.setLoadPanelVisible(false));
    }
    return (<>
        {props.showPopup.visible == true ? (
            <Popup
                visible={props.showPopup.visible}
                onHiding={() => props.setShowPopup(prevFormData => ({ ...prevFormData, visible: false }))}
                dragEnabled={true}
                closeOnOutsideClick={false}
                showCloseButton={true}
                title="Auto Select Locations"
                width={400}
                height={250}
            >

                <div className="row">
                    <div className="col-md-12">
                        <SelectBox
                            onValueChanged={(e) => setSelectedPickMethod(prevState => ({ ...prevState, LocationPickMethod: e.value }))}
                            value={selectedPickMethod.LocationPickMethod}
                            dataSource={LocationPickMethodOptions}
                            displayExpr="name"
                            valueExpr="id"
                            labelMode='static'
                            stylingMode='outlined'
                            label="Pick Method"
                        />

                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <SelectBox
                            onValueChanged={(e) => setSelectedPickMethod(prevState => ({ ...prevState, LocationPickSeqMethod: e.value }))}
                            value={selectedPickMethod.LocationPickSeqMethod}
                            dataSource={SortDirectionOptions}
                            displayExpr="name"
                            valueExpr="id"
                            className="mt-2"
                            labelMode='static'
                            stylingMode='outlined'
                            label="Pick Seq"
                        />

                    </div>
                </div>
                <div className="row">
                    <div className="col-md-3">
                        <Button className="mt-2" text="Ok" type="default" onClick={() => callStageChangeProcedure()} />
                    </div>
                    <div className="col-md-6">
                        <Button className="mt-2" text="Cancel" type="default" onClick={() => props.setShowPopup(prevFormData => ({ ...prevFormData, visible: false }))} />
                    </div>
                </div>
            </Popup>) : (null)}
    </>);
}
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(AutoSelectLocationPopup);
